import React from "react";
import { resolvePublicUploadUrl } from "../../../api/apiConfig/apiConfig";
import { WALLET_FALLBACK_ICON, fallbackCoinImg } from "./walletPageUiConstants";

function SheetKv({ rowItem, safeRound, totalWalletQty, approxUsdLine, usdApproxFromPrice, spotUsdPriceLabel, includeTotalKv, actionsClassSuffix, renderActionButtons, onClosePopup }) {
  const tot = totalWalletQty(rowItem);
  return (
    <>
      <div className="agce-ao-sheet__hero">
        <div className="agce-ao-sheet__hero-num">{safeRound(tot)}</div>
        <div className="agce-ao-sheet__hero-fiat">{approxUsdLine(rowItem)}</div>
      </div>
      <div className="agce-ao-sheet__kvlist">
        <div className="agce-ao-sheet__kv">
          <span>Available</span>
          <span className="agce-ao-sheet__kv-val text-end">
            <span className="d-block">{safeRound(rowItem.balance)}</span>
            <span className="d-block funding-account__subnum">{usdApproxFromPrice(rowItem.balance, rowItem)}</span>
          </span>
        </div>
        <div className="agce-ao-sheet__kv">
          <span>In-Order</span>
          <span className="agce-ao-sheet__kv-val text-end">
            <span className="d-block">{safeRound(rowItem.locked_balance)}</span>
            <span className="d-block funding-account__subnum">{usdApproxFromPrice(rowItem.locked_balance, rowItem)}</span>
          </span>
        </div>
        <div className="agce-ao-sheet__kv">
          <span>Avg. Cost Price (USD)</span>
          <span className="agce-ao-sheet__kv-val text-end">{spotUsdPriceLabel(rowItem)}</span>
        </div>
        {includeTotalKv ? (
          <div className="agce-ao-sheet__kv">
            <span>Total Balance</span>
            <span className="agce-ao-sheet__kv-val agce-ao-sheet__kv-val--accent">{safeRound(tot)}</span>
          </div>
        ) : null}
      </div>
      <div className="agce-ao-sheet__divider" />
      <div className={`agce-ao-sheet__table-actions${actionsClassSuffix || ""}`}>{renderActionButtons(rowItem, onClosePopup)}</div>
    </>
  );
}

/** Mobile balance sheet shared by unified (`list`) and spot (`spot`) surfaces */
export default function WalletRowPopup({
  walletRowPopup,
  isSpotSurface,
  setWalletRowPopup,
  renderActionButtons,
  totalWalletQty,
  safeRound,
  approxUsdLine,
  usdApproxFromPrice,
  spotUsdPriceLabel,
}) {
  if (!walletRowPopup) return null;

  return (
    <>
      <div className="agce-ao-detail-backdrop" role="presentation" onClick={() => setWalletRowPopup(null)} />
      <div
        className="modal fade show d-flex agce-ao-sheet-modal"
        tabIndex="-1"
        role="dialog"
        aria-modal="true"
        aria-labelledby="walletRowPopupTitle"
        style={{ zIndex: 1060 }}
      >
        <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable agce-ao-sheet-dialog">
          <div className="modal-content agce-ao-sheet border-0">
            {!isSpotSurface && walletRowPopup.kind === "list" && walletRowPopup.item ? (
              <>
                <h2 id="walletRowPopupTitle" className="visually-hidden">
                  {walletRowPopup.item?.short_name} details
                </h2>
                <div className="agce-ao-sheet__header">
                  <div className="agce-ao-sheet__brand">
                    <img
                      className="agce-ao-sheet__coin"
                      src={resolvePublicUploadUrl(walletRowPopup.item?.icon_path)}
                      alt=""
                      onError={fallbackCoinImg}
                    />
                    <div>
                      <div className="agce-ao-sheet__sym">{walletRowPopup.item.short_name}</div>
                      <div className="agce-ao-sheet__fullname">{walletRowPopup.item.currency}</div>
                    </div>
                  </div>
                  <button type="button" className="btn-close agce-ao-sheet__close" aria-label="Close" onClick={() => setWalletRowPopup(null)} />
                </div>
                <div className="modal-body agce-ao-sheet__body">
                  <SheetKv
                    rowItem={walletRowPopup.item}
                    safeRound={safeRound}
                    totalWalletQty={totalWalletQty}
                    approxUsdLine={approxUsdLine}
                    usdApproxFromPrice={usdApproxFromPrice}
                    spotUsdPriceLabel={spotUsdPriceLabel}
                    includeTotalKv
                    actionsClassSuffix=""
                    renderActionButtons={renderActionButtons}
                    onClosePopup={() => setWalletRowPopup(null)}
                  />
                </div>
              </>
            ) : null}
            {isSpotSurface && walletRowPopup.kind === "spot" && walletRowPopup.item ? (
              <>
                <h2 id="walletRowPopupTitle" className="visually-hidden">
                  {walletRowPopup.item?.short_name} details
                </h2>
                <div className="agce-ao-sheet__header">
                  <div className="agce-ao-sheet__brand">
                    <img
                      className="agce-ao-sheet__coin"
                      src={
                        walletRowPopup.item?.icon_path ? resolvePublicUploadUrl(walletRowPopup.item.icon_path) : WALLET_FALLBACK_ICON
                      }
                      alt=""
                      onError={fallbackCoinImg}
                    />
                    <div>
                      <div className="agce-ao-sheet__sym">{walletRowPopup.item.short_name}</div>
                      <div className="agce-ao-sheet__fullname">{walletRowPopup.item.currency}</div>
                    </div>
                  </div>
                  <button type="button" className="btn-close agce-ao-sheet__close" aria-label="Close" onClick={() => setWalletRowPopup(null)} />
                </div>
                <div className="modal-body agce-ao-sheet__body">
                  <SheetKv
                    rowItem={walletRowPopup.item}
                    safeRound={safeRound}
                    totalWalletQty={totalWalletQty}
                    approxUsdLine={approxUsdLine}
                    usdApproxFromPrice={usdApproxFromPrice}
                    spotUsdPriceLabel={spotUsdPriceLabel}
                    includeTotalKv={false}
                    actionsClassSuffix=" agce-ao-sheet__table-actions--spot"
                    renderActionButtons={renderActionButtons}
                    onClosePopup={() => setWalletRowPopup(null)}
                  />
                </div>
              </>
            ) : null}
          </div>
        </div>
      </div>
    </>
  );
}
